/*
 * App actions
 */

import {
  WINDOW_RESIZE,
} from './constants';

export function windowResize(windowSizing) {
  return {
    type: WINDOW_RESIZE,
    windowWidth: windowSizing.windowWidth,
    windowHeight: windowSizing.windowHeight,
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions.js
 **/